// Modül 4 - Kritik Hatalar - TAM İNTERAKTİF İÇERİKLER

const cabinCrewContentsM4Interactive = {
  // ÜNİTE 1: EZBER VE AŞIRI ÖZGÜVEN
  'CM-M4-U1-L1': {
    lesson_id: 'CM-M4-U1-L1',
    title: 'Ezber vs Doğallık',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '🧠 Ezber Cevaplar vs Doğallık',
      intro: 'Jüri ezber cevapları hemen anlar!',
      facts: [
        { icon: '❌', title: 'Ezber', text: 'Robotik, ruhsuz, samimiyetsiz' },
        { icon: '✅', title: 'Doğal', text: 'Samimi, içten, gerçek' },
        { icon: '🎯', title: 'Hedef', text: 'Kişiliğinizi göstermek' },
        { icon: '⚠️', title: 'Risk', text: 'Ezber = Güvensizlik algısı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Neden ezber kötü?',
        options: [
          { text: 'Hazırlık gösterir', isCorrect: false, feedback: '❌ Aşırı hazırlık = yapay!' },
          { text: 'Robotik ve samimiyetsiz görünür', isCorrect: true, feedback: '✅ Jüri gerçek kişiliği görmek ister!' },
          { text: 'Fark edilmez', isCorrect: false, feedback: '❌ Jüri hemen anlar!' }
        ]
      }
    }
  },

  'CM-M4-U1-L2': {
    lesson_id: 'CM-M4-U1-L2',
    title: 'Gerçek Refleks',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '⚡ Gerçek Refleksler',
      intro: 'Doğal tepkiler nasıl geliştirilir?',
      steps: [
        { level: 1, title: 'Anla', desc: 'Soruyu gerçekten anla' },
        { level: 2, title: 'Düşün', desc: '2-3 saniye düşün, acele etme' },
        { level: 3, title: 'Kişiselleştir', desc: 'Kendi tecrübenden örnek ver' },
        { level: 4, title: 'Samimi Ol', desc: 'Gerçek duygularını yansıt' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Doğal cevap nasıl verilir?',
        options: [
          { text: 'Hemen, düşünmeden', isCorrect: false, feedback: '❌ Biraz düşünün!' },
          { text: 'Kısa düşünüp, kişisel örnekle', isCorrect: true, feedback: '✅ 2-3 saniye düşünüp samimi cevap!' },
          { text: '5 dakika düşünerek', isCorrect: false, feedback: '❌ Çok uzun!' }
        ]
      }
    }
  },

  'CM-M4-U1-L3': {
    lesson_id: 'CM-M4-U1-L3',
    title: 'Senaryo: Ezber Testi',
    type: 'scenario',
    duration: 5,
    xp: 30,
    scenario: {
      question: '🎭 SENARYO: Beklenmedik Soru',
      context: 'Jüri "Neden kabin memuru olmak istiyorsunuz?" yerine "Kabin memurluğu sizi neden MUTSUZ edebilir?" diye soruyor.',
      options: [
        { id: 'A', text: 'Dürüstçe zorlu yönleri kabul eder, nasıl başa çıkacağımı anlatırım', isCorrect: true },
        { id: 'B', text: 'Hiçbir şey mutsuz etmez derim', isCorrect: false },
        { id: 'C', text: 'Ezber cevabımı söylerim', isCorrect: false },
        { id: 'D', text: 'Soruyu anlayamadım derim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Dürüstlük ve öz farkındalık!',
        wrong: '❌ Jüri farkındalığınızı test ediyor. Hiçbir iş mükemmel değil!'
      },
      explanation: 'Uzun uçuşlar, jet lag, ailenden uzak kalma... Bunları kabul edip nasıl başa çıktığınızı anlatın.'
    }
  },

  // ÜNİTE 2: YAYGIN HATALAR
  'CM-M4-U2-L1': {
    lesson_id: 'CM-M4-U2-L1',
    title: 'Aşırı Konuşma',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '🗣️ Aşırı Konuşma Hatası',
      intro: 'Çok konuşmak = Kendi kuyunu kazmak',
      facts: [
        { icon: '⏱️', title: 'Süre', text: 'Cevap 30-60 saniye olmalı' },
        { icon: '🎯', title: 'Öz', text: 'Gereksiz detaylardan kaçın' },
        { icon: '👥', title: 'Paylas', text: 'Başkalarına da fırsat bırak' },
        { icon: '⚠️', title: 'Risk', text: 'Uzun konuşma = Egoist algısı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İdeal cevap süresi?',
        options: [
          { text: '10 saniye', isCorrect: false, feedback: '❌ Çok kısa!' },
          { text: '30-60 saniye', isCorrect: true, feedback: '✅ Öz ve yeterli!' },
          { text: '3-5 dakika', isCorrect: false, feedback: '❌ Çok uzun, başkalarına fırsat yok!' }
        ]
      }
    }
  },

  'CM-M4-U2-L2': {
    lesson_id: 'CM-M4-U2-L2',
    title: 'Yetersiz Hazırlık',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '📚 Hazırlık Eksikliği',
      intro: 'Hazırlıksız gelmek = Saygısızlık',
      categories: [
        { icon: '✅', title: 'Şirketi Araştır', examples: 'Tarih, filo, değerler', desc: 'Web sitesini oku' },
        { icon: '✅', title: 'Haberleri Takip', examples: 'Son gelişmeler', desc: 'Sektör haberleri' },
        { icon: '✅', title: 'Sorular Hazırla', examples: 'Akıllı sorular', desc: 'İlgi gösterir' },
        { icon: '❌', title: 'Bilmemek', examples: '"Şirket hakkında bilgim yok"', desc: 'Kesin eleme!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakat öncesi ne yapmalı?',
        options: [
          { text: 'Sadece CV hazırlamak', isCorrect: false, feedback: '❌ Yetersiz!' },
          { text: 'Şirketi, sektörü ve haberleri araştırmak', isCorrect: true, feedback: '✅ Kapsamlı hazırlık!' },
          { text: 'Hiçbir şey, doğallık önemli', isCorrect: false, feedback: '❌ Hazırlık şart!' }
        ]
      }
    }
  },

  'CM-M4-U2-L3': {
    lesson_id: 'CM-M4-U2-L3',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'Ezber cevap neden kötü?', options: ['Hazırlık', 'Samimiyetsiz', 'Profesyonel', 'İyi'], correct: 1 },
        { q: 'İdeal cevap süresi?', options: ['5 sn', '30-60 sn', '5 dk', '10 dk'], correct: 1 },
        { q: 'Hazırlıkta ne yapmalı?', options: ['Hiçbir şey', 'Şirketi araştır', 'Sadece kıyafet', 'Sadece CV'], correct: 1 },
        { q: 'Aşırı konuşma ne izlenimi verir?', options: ['Bilgili', 'Egoist', 'Alçak gönüllü', 'Profesyonel'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 3: DAVRANIŞ HATALARI
  'CM-M4-U3-L1': {
    lesson_id: 'CM-M4-U3-L1',
    title: 'Negatif Beden Dili',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🚫 Negatif Beden Dili',
      intro: 'Vücudunuz sizi ele verir!',
      facts: [
        { icon: '❌', title: 'Kol Kavşturma', text: 'Savunmacı, kapalı' },
        { icon: '❌', title: 'Göz Kaçırma', text: 'Güvensiz, yalancı algısı' },
        { icon: '❌', title: 'Çökük Duruş', text: 'Özgüvensiz' },
        { icon: '❌', title: 'Kıpırdanma', text: 'Gergin, rahatsız' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Hangi beden dili olumlu?',
        options: [
          { text: 'Kollar kavuşturuk', isCorrect: false, feedback: '❌ Kapalılık!' },
          { text: 'Dik duruş, açık kollar', isCorrect: true, feedback: '✅ Güven ve açıklık!' },
          { text: 'Ayakları sallama', isCorrect: false, feedback: '❌ Gerginlik!' }
        ]
      }
    }
  },

  'CM-M4-U3-L2': {
    lesson_id: 'CM-M4-U3-L2',
    title: 'Yanlış İletişim',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🗣️ İletişim Hataları',
      intro: 'Sözleriniz sizi ele verebilir',
      categories: [
        { icon: '❌', title: 'Olumsuz', examples: '"Yapamam", "Zor"', desc: 'Negatif algı' },
        { icon: '❌', title: 'Eleştiri', examples: 'Eski işi kötüleme', desc: 'Profesyonellik eksik' },
        { icon: '✅', title: 'Pozitif', examples: '"Deneyebilirim"', desc: 'Çözüm odaklı' },
        { icon: '✅', title: 'Yapıcı', examples: '"Öğrendim"', desc: 'Gelişim odaklı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Eski işyeriniz hakkında ne söylemeli?',
        options: [
          { text: 'Kötüydü, patron berbattı', isCorrect: false, feedback: '❌ Asla kötüleme!' },
          { text: 'Çok şey öğrendim, şimdi yeni fırsatlar arıyorum', isCorrect: true, feedback: '✅ Pozitif ve yapıcı!' },
          { text: 'Konuşmak istemiyorum', isCorrect: false, feedback: '❌ Şüpheli!' }
        ]
      }
    }
  },

  'CM-M4-U3-L3': {
    lesson_id: 'CM-M4-U3-L3',
    title: 'Senaryo: Kötü İzlenimler',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      question: '😰 SENARYO: Kötü İzlenim',
      context: 'Mülakatta eliniz titremeye başladı, sesiniz kısıldı. Gerginliğiniz belli oluyor. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Derin nefes alır, kısa bir an durur ve devam ederim', isCorrect: true },
        { id: 'B', text: 'Panik yaparım', isCorrect: false },
        { id: 'C', text: '"Çok gerginim" derim', isCorrect: false },
        { id: 'D', text: 'Mülakatı bırakırım', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Doğru! Kısa mola ve nefes teknikleri!',
        wrong: '❌ Gerginlik normal. Önemli olan nasıl yönettiğiniz.'
      },
      explanation: 'Jüri de biliyor ki herkes gergin. Önemli olan toparlanma yeteneğiniz.'
    }
  },

  'CM-M4-U3-L4': {
    lesson_id: 'CM-M4-U3-L4',
    title: '🎮 Hata Bul Quiz',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Kol kavşturma açıklık gösterir.', isTrue: false, explanation: '❌ Kapalılık ve savunma!' },
        { statement: 'Eski işyerini eleştirmek normaldir.', isTrue: false, explanation: '❌ Asla kötüleme!' },
        { statement: 'Gerginlik normal, yönetmek önemli.', isTrue: true, explanation: '✅ Herkes gergin, önemli olan kontrol!' },
        { statement: 'Göz teması çok önemlidir.', isTrue: true, explanation: '✅ Güven ve ilgi gösterir!' },
        { statement: '5 dakika konuşmak iyidir.', isTrue: false, explanation: '❌ 30-60 saniye ideal!' }
      ]
    }
  },

  // ÜNİTE 4: HAZIRLIK HATALARI
  'CM-M4-U4-L1': {
    lesson_id: 'CM-M4-U4-L1',
    title: 'Araştırma Eksikliği',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🔍 Araştırma Eksikliği',
      intro: '"Şirket hakkında bilgim yok" = Eleme',
      facts: [
        { icon: '🏢', title: 'Şirketi Tanı', text: 'Tarih, misyon, vizyon' },
        { icon: '✈️', title: 'Filoyu Bil', text: 'Hangi uçaklar, kaç tane' },
        { icon: '🌐', title: 'Rotaları Bil', text: 'Nereye uçuyor' },
        { icon: '📰', title: 'Haberleri Takip', text: 'Son gelişmeler' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'THY mülakatı öncesi ne bilmeli?',
        options: [
          { text: 'Sadece "Türk Hava Yolları"', isCorrect: false, feedback: '❌ Çok yetersiz!' },
          { text: 'Tarih, filo, rotalar, son haberler', isCorrect: true, feedback: '✅ Kapsamlı araştırma!' },
          { text: 'Hiçbir şey, sorularla öğrenirim', isCorrect: false, feedback: '❌ İlgi eksikliği!' }
        ]
      }
    }
  },

  'CM-M4-U4-L2': {
    lesson_id: 'CM-M4-U4-L2',
    title: 'Pratik Eksikliği',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🎭 Pratik Eksikliği',
      intro: 'Pratik yapmadan mülakat = Kumar',
      steps: [
        { level: 1, title: '📝 Soruları Listele', desc: 'Sık sorulan soruları hazırla' },
        { level: 2, title: '🗣️ Cevapla', desc: 'Sesli pratik yap' },
        { level: 3, title: '📹 Kaydet', desc: 'Kendini izle, geliştir' },
        { level: 4, title: '👥 Arkadaşla', desc: 'Mock interview yap' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En etkili pratik yöntemi?',
        options: [
          { text: 'Kafadan okumak', isCorrect: false, feedback: '❌ Yetersiz!' },
          { text: 'Sesli pratik + video kayıt', isCorrect: true, feedback: '✅ Kendini gör ve düzelt!' },
          { text: 'Hiç pratik yapmamak', isCorrect: false, feedback: '❌ Kumar!' }
        ]
      }
    }
  },

  'CM-M4-U4-L3': {
    lesson_id: 'CM-M4-U4-L3',
    title: 'Lojistik Hatalar',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🚕 Lojistik Hatalar',
      intro: 'Geç kalmak = İlk izlenim yok!',
      facts: [
        { icon: '⏰', title: 'Erken Git', text: '30 dk önce orada ol' },
        { icon: '🗺️', title: 'Yolu Öğren', text: 'Önceki gün git, yolu gör' },
        { icon: '👔', title: 'Kıyafet Hazırla', text: 'Önceki gece ütüle' },
        { icon: '📱', title: 'Belgeler', text: 'CV, fotoğraf, kimlik' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakat günü kaç dakika önce orada olmalı?',
        options: [
          { text: 'Tam saatinde', isCorrect: false, feedback: '❌ Geç kalırsanız bitti!' },
          { text: '30 dakika önce', isCorrect: true, feedback: '✅ Rahatlama ve hazırlık süresi!' },
          { text: '2 saat önce', isCorrect: false, feedback: '❌ Çok erken, stresli!' }
        ]
      }
    }
  },

  'CM-M4-U4-L4': {
    lesson_id: 'CM-M4-U4-L4',
    title: '⚡ Hata Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Ezber cevap neden kötü?', options: ['Profesyonel', 'Samimiyetsiz', 'Doğal', 'Akıllı'], correct: 1 },
        { q: 'Kaç dakika önce orada ol?', options: ['0', '10', '30', '120'], correct: 2 },
        { q: 'Kol kavşturma ne ifade eder?', options: ['Açıklık', 'Kapalılık', 'Güven', 'Rahatlama'], correct: 1 },
        { q: 'Eski işyeri hakkında?', options: ['Eleştir', 'Kötüle', 'Pozitif ol', 'Anlat'], correct: 2 },
        { q: 'İdeal cevap süresi?', options: ['5 sn', '30-60 sn', '5 dk', '10 dk'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 5: PSİKOLOJİK TUZAKLAR
  'CM-M4-U5-L1': {
    lesson_id: 'CM-M4-U5-L1',
    title: 'Aşırı Stres Yönetimi',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🧘 Stres Yönetimi',
      intro: 'Stres normal, kontrol şart!',
      facts: [
        { icon: '🌬️', title: 'Nefes', text: '4-7-8 tekniği: 4 sn al, 7 sn tut, 8 sn ver' },
        { icon: '🧘', title: 'Gevşe', text: 'Omuzları düşür, çeneyi gevşet' },
        { icon: '💭', title: 'Pozitif', text: '"Yapabilirim" man trası' },
        { icon: '😴', title: 'Uyku', text: 'Önceki gece iyi uyu' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakatta gerginlik hissederseniz?',
        options: [
          { text: 'Panik yaparım', isCorrect: false, feedback: '❌ Kontrol kaybı!' },
          { text: 'Derin nefes alır, kısa durur, devam ederim', isCorrect: true, feedback: '✅ Profesyonel toparlanma!' },
          { text: 'Mülakatı bırakırım', isCorrect: false, feedback: '❌ Şansınızı kaybedersiniz!' }
        ]
      }
    }
  },

  'CM-M4-U5-L2': {
    lesson_id: 'CM-M4-U5-L2',
    title: 'Kararsızlık ve Aşırı Düşünme',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🤔 Aşırı Düşünme Tuzağı',
      intro: 'Fazla düşünmek = Felce uğramak',
      categories: [
        { icon: '❌', title: 'Over-thinking', examples: '"Ya yanlış söylersem"', desc: 'Felce uğratır' },
        { icon: '❌', title: 'Kararsızlık', examples: '"Hangisini seçeyim"', desc: 'Zayıf görünürsünüz' },
        { icon: '✅', title: 'Güven', examples: 'Karar ver, savun', desc: 'Özgüvenli görünün' },
        { icon: '✅', title: 'Akış', examples: 'Düşün ama takılma', desc: 'Doğal devam' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Cevabı bilmiyorsanız?',
        options: [
          { text: '5 dakika düşünürüm', isCorrect: false, feedback: '❌ Çok uzun!' },
          { text: 'Kısaca düşünüp dürüst cevap veririm', isCorrect: true, feedback: '✅ Dürüstlük + hız!' },
          { text: 'Uydururum', isCorrect: false, feedback: '❌ Yanlış!' }
        ]
      }
    }
  },

  'CM-M4-U5-L3': {
    lesson_id: 'CM-M4-U5-L3',
    title: 'Senaryo: Panik Anı',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      question: '😨 SENARYO: Panik',
      context: 'Mülakatta kafanız bomboş kaldı. Soruyu unuttunuz, ne söyleyeceğinizi bilmiyorsunuz. Ne yaparsınız?',
      options: [
        { id: 'A', text: '"Bir saniye düşünebilir miyim?" der, nefes alır, toplatırım', isCorrect: true },
        { id: 'B', text: 'Ağlamaya başlarım', isCorrect: false },
        { id: 'C', text: 'Odadan çıkarım', isCorrect: false },
        { id: 'D', text: 'Rastgele bir şeyler söylerim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Kısa mola istemek normaldir!',
        wrong: '❌ Panik normal, kontrol önemli. "Düşünebilir miyim?" demek kabul edilir.'
      },
      explanation: 'Jüri de insan. Kısa bir mola istemek profesyonelliktir.'
    }
  },

  'CM-M4-U5-L4': {
    lesson_id: 'CM-M4-U5-L4',
    title: '🎮 Stres Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      instruction: 'Stres tekniklerini eşleştir',
      pairs: [
        { id: 1, left: '4-7-8 Tekniği', right: 'Nefes egzersizi' },
        { id: 2, left: 'Pozitif Düşünce', right: '"Yapabilirim" mantrası' },
        { id: 3, left: 'Kısa Mola', right: '"Düşünebilir miyim?"' },
        { id: 4, left: 'İyi Uyku', right: 'Önceki gece dinlen' },
        { id: 5, left: 'Vücut Gevşetme', right: 'Omuz ve çene' }
      ]
    }
  },

  // ÜNİTE 6: FİNAL
  'CM-M4-U6-L1': {
    lesson_id: 'CM-M4-U6-L1',
    title: '🎓 Modül 4 Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'Ezber cevap neden kötü?', options: ['Hazırlık', 'Samimiyetsiz', 'Profesyonel', 'Akıllı'], correct: 1 },
        { q: 'Kaç dakika önce orada ol?', options: ['0', '10', '30', '120'], correct: 2 },
        { q: 'İdeal cevap süresi?', options: ['5 sn', '30-60 sn', '5 dk', '10 dk'], correct: 1 },
        { q: 'Kol kavşturma?', options: ['Açıklık', 'Kapalılık', 'Güven', 'Rahatlama'], correct: 1 },
        { q: 'Eski işyeri hakkında?', options: ['Eleştir', 'Kötüle', 'Pozitif ol', 'Şikayet et'], correct: 2 },
        { q: 'Gerginlikte ne yap?', options: ['Panik', 'Nefes al', 'Kaç', 'Ağla'], correct: 1 },
        { q: 'Bilmiyorsan?', options: ['Uydur', 'Dürüst ol', 'Sus', 'Kaçın'], correct: 1 },
        { q: 'Pratik nasıl yapılır?', options: ['Kafadan', 'Sesli + video', 'Okuyarak', 'Yazmadan'], correct: 1 },
        { q: 'Panik anında?', options: ['Ağla', 'Kaç', 'Kısa mola iste', 'Uydur'], correct: 2 },
        { q: 'Nefes tekniği?', options: ['1-2-3', '4-7-8', '10-10-10', '5-5-5'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM4Interactive;
